import React from "react";
import { useNavigate } from "react-router";

function HomeScreenPopularImageTools() {
  //react router navigate
  const navigate = useNavigate(); //react router navigate
  return (
    <div className="container text-center">
      {/* Title */}
      <div style={{ marginTop: "5rem" }}>
        <label className="display-6 fw-bold text-dark">
          Your Favourite Image Tools
        </label>
      </div>

      <div className=" mt-2">
        <label className="fs-6">
          Free image tools. No Download. Edit Online/Offline.
        </label>
      </div>

      {/* Popular Tools grid */}
      <div className="mt-5">
        {/* Tools grid */}
        <div className="row">
          {/* Image Compressor */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/image_resizer", {
                state: { title: "Compress Images & Resize Images Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Compress Images</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Reduce size of images without loosing quality.
                </p>
              </div>
            </div>
          </div>

          {/* Crop Image */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/crop_image", {
                state: { title: "Trim & Crop Image For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Trim & Crop Image</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Crop JPG, PNG or GIF by defining a rectangle in pixels.
                </p>
              </div>
            </div>
          </div>

          {/* Rotate Image */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/flip_image", {
                state: { title: "Rotate & Flip Images For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Rotate & Flip Image</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Batch rotate & flip images. Flip your image horizontally or
                  vertically.
                </p>
              </div>
            </div>
          </div>

          {/* Image Converter */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/image_converter", {
                state: { title: "Convert & Edit Images For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Image Converter</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Convert images from JPG to PNG, PNG to JPG, JPG to WEBP etc.
                </p>
              </div>
            </div>
          </div>

          {/* Merge Images */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/merge_images", {
                state: { title: "Merge & Join Images For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Image Merger</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Merge two or more images vertically or horizontally to create
                  a new image.
                </p>
              </div>
            </div>
          </div>

          {/* Split Image */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/split_image", {
                state: { title: "Split Image Into Parts For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Image Splitter</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Split an image horizontally, vertically or both.
                </p>
              </div>
            </div>
          </div>

          {/* Watermark Image */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/watermark_image", {
                state: { title: "Bulk Watermark Images For Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Watermark Image</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Protect your digital images with custom watermarks.
                </p>
              </div>
            </div>
          </div>

          {/* Image Resizer*/}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/image_resizer", {
                state: { title: "Image Resizer & Image Compressor Free" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Image Resizer</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Resize and compress images under 200KB.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenPopularImageTools;
